<template>
  <div class="content">
    <template v-if="showTable===1">
      <packageTable
        ref="contentBaseRef"
        class="contentBaseRef"
        :columnsData="columnsheader"
        :tableData="tableDataList"
        :reduceheight="reduceheight"
        :loading="tableLoading"
        :border="true"
        :showTableHeader="true"
        :showSearchBtn="false"
        :tabletotallen="getPageTotal"
        :tablePageSize="reqBase.page_size"
        @pageonChange="pageonChange"
        @pageSizeChange="pageSizeChange"
        @refreshBtn="init"
        @getSelect="getSelectList"
      >
        <template slot="headLeft">
          <Form v-if="showTable===1" ref="formInline" :model="form_filter" class="tableHeaderForm" @keydown.enter.native="search" inline>
            <FormItem>
              <Input type="text" style="width:120px" v-model="form_filter.project_name" placeholder="项目名称筛选" />
            </FormItem>
            <FormItem v-if="showTable===1">
              <Select v-model="form_filter.company_code" style="width:120px">
                <Option v-for="(item,index) in companyList" :key="'scompanyList'+index" :value="item.company_code">{{ item.company_name }}</Option>
              </Select>
            </FormItem>
            <FormItem class="reduceFromMarginLeft">
              <Button v-for="(item,index) in topButtonList" :type="item.type" style="margin-right: 5px;" @click="item.method" :key="index">{{item.name}}</Button>
            </FormItem>
          </Form>
        </template>
        <template slot="headRight">
          <Tooltip :content="showTable?'切换成宫格':'切换成表格'">
            <Button type="primary" @click="changeList" style="margin-right: 5px;" :icon="showTable?'ios-keypad-outline':'md-reorder'"></Button>
          </Tooltip>
          <Tooltip v-for="(item,index) in topButtonList1" :key="index" :content="item.name" placement="bottom">
            <Button :type="item.type" style="margin-right: 5px;" @click="item.method" :key="index" :icon="item.icon"></Button>
          </Tooltip>
        </template>
      </packageTable>
    </template>

    <div v-else ref="gridCom" style="overflow:hidden">
      <Row :gutter="16">
        <Col v-if="userInfo===1" :span="userInfo===1?5:0">
          <Card title="Options" icon="ios-options" class="cardArea" :style="{height:tableHeight+'px'}">
            <div slot="title">
              <Input search enter-button="搜索" @on-search="onSearchCompany" placeholder="公司名称搜索" />
            </div>
            <CellGroup v-if="companyList.length>0" @on-click="cellGroupClick">
              <Cell v-for="(item,index) in companyList" :key="'companyList'+index" :name="item.company_code" :title="item.company_name" :selected="item.selected" />
            </CellGroup>
            <div v-else class="emptyClass">暂无公司</div>
            <Spin size="large" fix v-if="spinShow"></Spin>
          </Card>
        </Col>
        <Col :span="userInfo===1?19:24">
          <Card :bordered="false" dis-hover class="cardArea" :style="{height:tableHeight-45+'px'}">
            <div slot="title">
              
            </div>
            <div slot="extra">
              <Tooltip :content="showTable?'切换成宫格':'切换成表格'">
                <Button type="primary" @click="changeList" style="margin-right: 5px;" :icon="showTable?'ios-keypad-outline':'md-reorder'"></Button>
              </Tooltip>
              <Tooltip v-for="(item,index) in topButtonList1" :key="index" :content="item.name" placement="bottom">
                <Button :type="item.type" style="margin-right: 5px;" @click="item.method" :key="index" :icon="item.icon"></Button>
              </Tooltip>
            </div>
            <Spin size="large" fix v-if="spinShow1"></Spin>
            <Row :gutter="16">
              <Col class="colMargin" :xs="8" :sm="8" :md="8" :lg="8" :xl="8" v-for="(item,index) in tableDataList1" :key="index">
                <Card>
                  <div>
                    <div class="cardInner" @click.prevent="mechanHome(item)">
                      <template v-if="item.project_pic_path">
                        <img :src="item.file_url" />
                      </template>
                      <template v-else>
                        <Icon class="iconNo" size="100" type="ios-image" />
                      </template>
                    </div>
                    <div style="padding-top:8px;">
                      <Row type="flex" justify="space-between" align="middle" :class="{rowClass:true,rowCheck:item.check?true:false}">
                        <Col span="17" class="colFlex" @click.prevent="mechanHome(item)">{{item.project_name}}</Col>
                        <Col span="7" style="text-align:right">
                          <template v-for="(list,index1) in operationButtonList">
                            <Tooltip v-if="list.icon" transfer :key="'icon'+index1" :content="list.name">
                              <Icon :size="18" class="colIcon" @click="list.method(item)" :type="list.icon" />
                            </Tooltip>
                          </template>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </Card>
          <div v-if="tableDataList1.length>0" class="content_base_page">
            <Page
              :total="getPageTotal1"
              ref="pageRef1"
              :page-size="reqBase1.page_size"
              :current="reqBase1.page"
              size="small"
              @on-change="pageOnchange1"
              @on-page-size-change="pageSizeChange"
              show-total
              show-elevator
            ></Page>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import packageTableMixins from "@/mixins/packageTableMixins"
import addAppCustom from "./components/addAppCustom"
import customDetails from "./components/customDetails.vue"
import config from "@/config/index"
import {
  project_add,
  project_list,
  project_del,
  project_update,
  company_list
} from "@/api/pests"
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    return {
      tableHeight: 400,
      tableDataList1: [],
      spinShow: false,
      spinShow1: false,
      companyList: [],
      reduceheight: 55,
      showTable: 0,
      setData: null,
      currClientId: null, //当前选择的应用id
      form_filter: {
        project_name: null,
        company_code: null
      },
      //共用的查询与重置
      topButtonList: [
        {
          name: "查询",
          type: "primary",
          method: this.search
        },
        {
          name: "重置",
          type: "error",
          method: this.reset
        }
      ],
      //共用的右侧添加按钮
      topButtonList1: [
        {
          name: "添加",
          icon: "ios-add",
          type: "primary",
          method: this.add
        },
        {
          name: "刷新",
          icon: "ios-refresh",
          type: "primary",
          method: this.refresh
        }
      ],
      reqBase: {
        page: 1,
        page_size: 10
      },
      reqBase1: {
        page: 1,
        page_size: 10
      },
      status: true, //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      getPageTotal1: 0,
      operationButtonList: [
        // {
        //   name:'进入项目',
        //   type:'primary',
        //   icon:'',
        //   method:this.mechanHome
        // },
        {
          name: "详情",
          type: "text",
          icon: "ios-paper-outline",
          method: this.details
        },
        {
          name: "编辑",
          type: "text",
          icon: "ios-create-outline",
          method: this.edit
        },
        {
          name: "删除",
          type: "text",
          icon: "ios-trash-outline",
          method: this.del
        }
      ],
      operationButtonList1: [
        {
          name: this.$t("operationModule.submitReview"),
          type: "primary",
          icon: "",
          method: this.submitReview
        }
      ],
      columnsheader: [
        // {
        //   align: "center",
        //   title: "序号",
        //   minWidth: 120,
        //   key: "xuhao"
        // },
        {
          align: "center",
          title: "项目",
          minWidth: 120,
          key: "project_name",
          render: (h, { row }) => {
            let vm = this
            return h(
              "div",
              {
                style: {
                  cursor: "pointer",
                  color: "#2d8cf0"
                },
                on: {
                  click: function () {
                    vm.mechanHome(row)
                  }
                }
              },
              row.project_name
            )
          }
        },
        {
          align: "center",
          title: "客户负责人",
          minWidth: 120,
          key: "customer_user"
        },
        {
          align: "center",
          title: "联系方式",
          minWidth: 120,
          key: "tel"
        },
        {
          align: "center",
          title: "地址",
          minWidth: 100,
          key: "address"
        },
        {
          align: "center",
          title: "创建日期",
          minWidth: 100,
          key: "addtime"
        },
        {
          align: "center",
          title: "操作",
          width: 200,
          key: "Operating",
          render: (h, { row }) => {
            let arr = []
            for (let i in this.operationButtonList) {
              let list = this.operationButtonList[i]
              arr.push(
                h(
                  "Button",
                  {
                    style: {
                      marginLeft: "5px",
                      marginBottom: "3px",
                      color: "#2d8cf0"
                    },
                    props: {
                      type: list.type,
                      size: list.size ? list.size : "small"
                    },
                    on: {
                      click: () => {
                        list.method(row)
                      }
                    }
                  },
                  list.name
                )
              )
            }

            return h("div", arr)
          }
        }
      ]
    }
  },
  components: {
    customDetails
  },
  computed: {
    userInfo() {
      let state = this.$store.state.user.userInfo.project_list_teshu
      return state
    }
  },
  methods: {
    onSearchCompany(value) {
      this.getcompany(value)
    },
    getcompany(company_name) {
      this.spinShow = true
      this.companyList.splice(0)
      let params = {}
      if (company_name) {
        params["company_name"] = company_name
      }
      company_list(params).then((res) => {
        this.spinShow = false
        if (res.result === 0) {
          let list = res.body || []
          if (company_name === undefined || company_name === "") {
            this.companyList.push({
              company_code: -1,
              company_name: "全部"
            })
          }
          for (let i in list) {
            let item = list[i]
            item.selected = false
            this.companyList.push(item)
          }
          if (this.companyList && this.companyList.length > 0) {
            this.$set(this.companyList[0], "selected", true)
            this.cellGroupClick(this.companyList[0].company_code)
          }
        } else {
          this.companyList = []
          this.$Message.error(res.errorMsg)
        }
      })
    },
    cellGroupClick(code) {
      for (let i in this.companyList) {
        let item = this.companyList[i]
        if (item.company_code === code) {
          item.selected = true
        } else {
          item.selected = false
        }
      }
      this.$set(this.reqBase1, "company_code", code)
      this.reqBase1.page = 1
      //重置当前的page
      // this.$refs.pageRef.current=1;
      this.init1()
    },
    gotoProject(item) {},
    init1() {
      this.spinShow1 = true
      this.tableDataList1.splice(0)
      let company_code = this.reqBase1.company_code
      if (company_code === -1) {
        company_code = null
      }
      project_list({ ...this.reqBase1, company_code }).then((res) => {
        this.spinShow1 = false
        if (res.result === 0) {
          this.tableDataList1 = res.body.list || []
          this.getPageTotal1 = res.body.total
        } else {
          this.tableDataList1 = []
          this.getPageTotal1 = 0
          this.$Message.error(res.errorMsg)
        }
      })
    },
    pageOnchange1(index) {
      this.reqBase1.page = index
      this.init1()
    },
    changeList() {
      if (this.showTable === 0) {
        if (this.tableDataList.length === 0) {
          this.init()
        }
        this.showTable = 1
      } else if (this.showTable === 1) {
        this.showTable = 0
      }
    },
    mechanHome(row) {
      this.$router.push({
        name: "projectManage",
        title: row.project_name,
        params: {
          code: row.project_code,
          name: row.project_name,
          id: row.id
        }
      })
    },
    pageSizeChange() {},
    init() {
      this.tableLoading = true
      project_list({ ...this.reqBase }).then((res) => {
        this.tableLoading = false
        this.tableDataList = []
        if (res.result === 0) {
          this.tableDataList = res.body.list || []
          this.getPageTotal = res.body.total
        } else {
          this.tableDataList = []
          this.getPageTotal = 0
          this.$Message.error(res.errorMsg)
        }
      })
    },
    //新增
    add() {
      let vm = this
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  "添加"
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove()
                    }
                  }
                })
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0"
              }
            }),
            h(addAppCustom, {
              ref: "addAppCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false
              }
            })
          ])
        },
        onOk: function () {
          let _this = this
          let obj = this.$refs.addAppCustom
          obj.checkForm().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formModel
              project_add(formModel).then((res) => {
                let msg = res.errorMsg
                if (res.result === 0) {
                  let msg = res.errorMsg
                  vm.$Message.success(msg)
                  vm.$Modal.remove()
                  if (vm.showTable === 0) {
                    vm.init1()
                  } else{
                    vm.init()
                  }
                } else {
                  vm.$Message.error(msg)
                  _this.buttonLoading = false
                }
              })
            } else {
              _this.buttonLoading = false
            }
          })
        }
      }
      this.$Modal.confirm(config)
    },
    search() {
      this.onSearch(this.form_filter)
    },
    reset() {
      this.form_filter = {
        project_name: null,
        company_code: null,
        status: -1
      }
      this.search()
    },
    details(row) {
      let vm = this
      let config = {
        loading: true,
        width: 800,
        okText: "关闭",
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "15px" } },
                  "详情"
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove()
                    }
                  }
                })
              ]
            ),
            h(customDetails, {
              ref: "customDetails",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                setData: row
              }
            })
          ])
        },
        onOk: function () {
          vm.$Modal.remove()
        }
      }
      this.$Modal.success(config)
    },
    edit(row) {
      let vm = this
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "15px" } },
                  "编辑"
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer"
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove()
                    }
                  }
                })
              ]
            ),
            h(addAppCustom, {
              ref: "addAppCustom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                setData: row
              }
            })
          ])
        },
        onOk: function () {
          let _this = this
          let obj = this.$refs.addAppCustom
          obj.checkForm().then((req) => {
            if (req) {
              //提交请求
              let formModel = obj.formModel
              project_update({
                ...formModel,
                company_code: row.company_code
              }).then((res) => {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg)
                  vm.$Modal.remove()
                  debugger
                  if (vm.showTable === 0) {
                    vm.init1()
                  } else{
                    vm.init()
                  }
                } else {
                  vm.$Message.error(res.errorMsg)
                  _this.buttonLoading = false
                }
              })
            } else {
              _this.buttonLoading = false
            }
          })
        }
      }
      this.$Modal.confirm(config)
    },
    del(row) {
      let vm = this
      let config = {
        loading: true,
        title:this.$t('删除') ,
        content:this.$t('您确定要删除')+row.project_name+'?',
        onOk: function () {
          let _this = this
          project_del({ id: row.id }).then((res) => {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg)
              vm.$Modal.remove()
              if (vm.showTable === 0) {
                    vm.init1()
                  } else{
                    vm.init()
                  }
            } else {
              vm.$Message.error(res.errorMsg)
              _this.buttonLoading = false
            }
          })
        }
      }
      this.$Modal.confirm(config)
    },
    refresh() {
      if (this.showTable === 0) {
        this.getcompany()
      } else {
        this.init()
      }
    },
    changeTableHeight() {
      this.tableHeight = window.innerHeight - this.$refs.gridCom.offsetTop - 10

      if (this.$refs.search) {
        let h = this.$refs.search.offsetHeight
        this.tableHeight = this.tableHeight - h
      } else {
        this.tableHeight = this.tableHeight - 45
      }
      console.log(this.tableHeight)
      return this.tableHeight
    }
  },
  mounted() {
    this.refresh()
    window.onresize = () => {
      this.changeTableHeight()
    }
    this.$nextTick(() => {
      this.changeTableHeight()
    })
  },
  created() {
    // this.getPageSizeToStorage();
  },
  destroyed() {
    window.onresize = null
  }
}
</script>
<style scoped>
.div2 {
  font-size: 15px;
  text-align: center;
}
.contentBaseRef /deep/ .headerWrapper {
  align-items: center;
}
.cardInner {
  display: block;
  height: 139px;
  overflow: hidden;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.cardInner img,
.cardInner .iconNo {
  max-width: 100%;
  /* max-height: 100%; */
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.headerWrapper {
  margin: 0 16px 0 10px;
}
.content {
  background: #fff;
  border: 1px solid #dcdcdc;
}
.colFlex {
  text-align: left;
}
.colIcon {
  cursor: pointer;
  margin-left: 4px;
}
.colFlex:hover,
.colIcon:hover {
  color: #2d8cf0;
}
.content_base_page {
  display: flex;
  justify-content: center;
  border-top: 1px solid #e9eaec;
  padding: 8px 0;
}
.colMargin {
  margin-bottom: 16px;
}
.rightCol {
  align-self: center;
}
.emptyClass {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cardArea {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.cardArea /deep/ .ivu-card-body {
  overflow-y: auto;
  flex: 1;
}
</style>
